<template>
  <ion-page>
    <div class="absolute-lt">
      <slot name="bg"></slot>
    </div>
    <native-bar />

    <!--  -->
    <slot name="header" v-if="slots.header">
      <component :is="slots.header" />
    </slot>
    <van-nav-bar v-else :style="{ backgroundColor: '#fff', color: '#000' }">
      <template #left>
        <slot name="left" v-if="props.showBackBtn">
          <div class="flex items-center" @click="toLeft">
            <van-icon name="arrow-left" size="20px" color="#000" />
          </div>
        </slot>
      </template>
      <template #title>
        <slot name="navTitle">
          <div
            class="flex items-center justify-center text-[#000] text-[36px] font-medium"
          >
            {{ title }}
          </div>
        </slot>
      </template>
      <template #right>
        <slot name="right"></slot>
      </template>
    </van-nav-bar>
    <ion-content :force-overscroll="false" :style="bgColorVar">
      <div class="h-full w-full scroll-ref" ref="scrollRef">
        <slot></slot>
      </div>
      <div slot="fixed" :class="fixedClass">
        <slot name="fixed"></slot>
      </div>
    </ion-content>
    <slot name="footer"></slot>
  </ion-page>
</template>

<script setup lang="tsx">
import { useSlots, computed, ref, onMounted } from 'vue';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  useIonRouter,
} from '@ionic/vue';
import { useUserStore } from '@/store';
import { useRoute } from 'vue-router';
// import BScroll from 'better-scroll';
import router from '@/router';
defineOptions({
  name: 'BasicLayout',
});
interface Props {
  /** 顶部工具栏标题 */
  title?: string;
  /** 是否显示返回按钮 */
  showBackBtn?: boolean;
  /** 固定元素的类名 */
  fixedClass?: string;
  /** toolbar内容占满100%宽 */
  toolbarContentFull?: boolean;
  backHandle?: () => void;
  hideBackText?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  showBackBtn: true,
  fixedClass: '',
  toolbarContentFull: false,
  hideBackText: true,
});

const scrollRef = ref(null);
// let bs = null;

// const addBscroll = () => {
//   bs = new BScroll(scrollRef.value!, {
//     probeType: 1, // 这个配置很重要
//     scrollY: true, // 垂直滚动
//     bounce: true, // 回弹效果
//     click: true, // 允许点击事件
//   });
// };

// onMounted(() => {
// setTimeout(addBscroll, 100);
// });

// const ionRouter = useIonRouter();
const route = useRoute();
const toLeft = () => {
  if (props.backHandle) {
    props.backHandle();
    return;
  }
  if (route.query.from) {
    let path = decodeURIComponent(route.query.from as string);
    // const url = new URL(path);
    const i = path.indexOf('?');
    if (i != -1) {
      const searchParams = path.substring(i + 1);
      const query = searchParams.split('&').reduce((prev: any, str) => {
        if (str) {
          const [key, value] = str.split('=');
          prev[key] = value;
        }
        return prev;
      }, {});
      path = path.substring(0, i);
      router.replace({
        path: path,
        // direction: 'back',
        query,
      });
    } else {
      router.replace({
        path: path,
        // direction: 'back',
      });
    }
  } else {
    router.back();
  }
};

const slots = useSlots();
const userStore = useUserStore();

const hasBgSlot = computed(() => Object.keys(slots).includes('bg'));

/** 透明背景用于设置沉浸状态栏的背景 */
const bgColorVar = computed(() =>
  hasBgSlot.value ? '--background: transparent' : '',
);
</script>
<style>
.custom-toolbar {
  --padding-top: 0 !important ;
  --padding-bottom: 0 !important ;
  --padding-start: 0 !important ;
  --padding-end: 0 !important ;
  /* --height: 92px; */
}
</style>
